module.exports = __webpack_public_path__ + "c_static/img/4关注店铺.30e74fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4关注店铺.jpg
// module id = 7b9x
// module chunks = 33